import { render, staticRenderFns } from "./CustomActiveClass.vue?vue&type=template&id=497f5ef1&scoped=true&"
import script from "./CustomActiveClass.vue?vue&type=script&lang=js&"
export * from "./CustomActiveClass.vue?vue&type=script&lang=js&"
import style0 from "./CustomActiveClass.vue?vue&type=style&index=0&id=497f5ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f5ef1",
  null
  
)

export default component.exports